import React, { PureComponent } from 'react'

import AuthContext from '../../main/authenticationProvider'
import DashboardService from '../../app/service/dashboardService'
import RouteService from '../../app/service/routeService'
import PlateService from '../../app/service/plateService'
import ReportsService from '../../app/service/reportsService'
import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';
import Moment from 'moment';
import towerIllumination from "../../assets/images/torres_iluminacao.png";
import blackTowerIllumination from "../../assets/images/torres_iluminacao_vinho.png";
import compressor from '../../assets/images/compressor.png';
import blackCompressor from "../../assets/images/compressor_vinho.png";
import noImage from "../../assets/images/sem_imagem.png";
import blackElectricGenerator from "../../assets/images/gerador-eletrico_vinho.png";
import electricGenerator from '../../assets/images/gerador-eletrico.png';
import ignicao from "../../assets/images/ignicao.svg"
import Loading from "../../components/loading";
import AppLayout from '../../components/layouts/AppLayout';
import './home.css';
import '../../views/custom-components.css'
import { Row, Col, Table, Card, Tooltip } from 'antd';
import styles from './home.module.scss';
import { LockOpenTwoTone, LockTwoTone } from "@material-ui/icons"
import { TableSearch } from '../../hooks'


const TIME_FETCH_DATA = 60000;




class ArlugHome extends PureComponent {
    constructor(props) {
        super(props);
        this.serviceDashboard = new DashboardService();
        this.serviceRoute = new RouteService();
        this.servicePlate = new PlateService();
        this.reportsService = new ReportsService();
        this.auth = new AuthContext();
        this.tableSearch = new TableSearch();
        this.state = {
            markers: [],
            showingInfoWindow: false,
            showingTrackInfoWindow: false,
            activeMarker: {},
            selectedPlace: {},
            showLoading: true,
            latitude: -15.7801,
            longitude: -47.9292,
            zoom: 6,
            routeSelected: null,
            triangleCoords: null,
            tracks: null,
            selectedTrack: {},
            loading: false,
            plateName: "",
            tablePageSize: 5,
            currentPage: 1,
            totalRegisters: 0,
            plates: [],
            selectedMarker: [],
            mapInstance: null,
        }
    }

    onMarkerClick = (props, marker) => {
        this.setState({
            activeMarker: marker,
            selectedPlace: props.information,
            showingInfoWindow: true
        });
    }

    onMarkerTrackClick = (props, marker) => {
        this.setState({
            activeMarker: marker,

        }, () => {
            this.setState({
                selectedTrack: props.information,
                showingTrackInfoWindow: true
            })
        });
    }

    onInfoWindowClose = () => {
        this.setState({
            activeMarker: null,
            showingInfoWindow: false,
            showingTrackInfoWindow: false
        });
    }

    interval = null;

    getIndex = (value, arr, prop) => {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i][prop] === value) {
                return i;
            }
        }
        return -1;
    }

    getData = (plateName, tablePageSize, currentPage) => {
        this.setState({
            showLoading: true
        });

        let options = [];
        let markers = [];
        this.serviceDashboard
            .getDashboardOutputs(plateName, tablePageSize, currentPage)
            .then(response => {

                response.data.data.forEach((element, index) => {

                    options.push({
                        key: index,
                        value: element.plate,
                        label: element.plate
                    });

                    markers.push({
                        key: index,
                        address: element.address,
                        date: element.date,
                        deviceId: element.deviceId,
                        horimeter: element.horimeter,
                        ignition: element.ignition,
                        latitude: element.latitude,
                        longitude: element.longitude,
                        mainBattery: element.mainBattery,
                        odometer: element.odometer,
                        plate: element.plate,
                        positionId: element.positionId,
                        output1: element.output1,
                        output2: element.output2,
                    });


                });

                let promises = markers.map((value, index) => {
                    return this.servicePlate.getPlate(value.plate).then((response) => {
                        if (response.status === 404) {

                        }
                        return {
                            ...value,
                            description: response.data.data.description,
                        }
                    }).catch((e) => {
                        return null;
                    });
                }).filter(promise => promise !== null);

                Promise.all(promises).then((results) => {

                    const finalList = results.filter((result) => result !== null);
                    const sortedList = finalList.sort((a, b) => {
                        if (a.ignition === "ON" && b.ignition === "OFF") return -1;
                        if (a.ignition === "OFF" && b.ignition === "ON") return 1;
                        return new Date(b.date) - new Date(a.date);
                    });

                    this.setState({
                        markers: sortedList,
                        totalRegisters: response.data.totalRegisters,
                        showLoading: false,
                        plates: options,
                    });
                });


            })
            .catch(erros => {
                this.setState({
                    showLoading: false,
                    markers: [],
                    totalRegisters: 0,
                });
                if (erros.response && erros.response.status === 401) {
                    this.auth.endSession();
                    this.props.history.push('/login');
                }
            });
    }


    handleRowClicked = row => {
        const selectedMarker = [{
            key: 0,
            address: row.address,
            date: row.date,
            deviceId: row.deviceId,
            horimeter: row.horimeter,
            ignition: row.ignition,
            latitude: row.latitude,
            longitude: row.longitude,
            mainBattery: row.mainBattery,
            odometer: row.odometer,
            plate: row.plate,
            positionId: row.positionId,
            output1: row.output1,
            output2: row.output2,
        }];
        this.setState({
            selectedMarker: selectedMarker,
            // latitude: row.latitude,
            // longitude: row.longitude,
            // zoom: 20,
        });

        this.state.mapInstance.setZoom(20);
        this.state.mapInstance.setCenter({ lat: parseFloat(row.latitude), lng: parseFloat(row.longitude) });


    }

    delayOnChangeSearch = (plateName, currentPage) => {
        this.setState({
            showLoading: true
        });

        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.getData(plateName, this.state.tablePageSize, currentPage), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentDidMount() {
        this.getData(this.state.plateName, this.state.tablePageSize, this.state.currentPage);
        this.interval = setInterval(() => {
            this.getData(this.state.plateName, this.state.tablePageSize, this.state.currentPage);
        }, TIME_FETCH_DATA);

        this.checkMarkersAndCenterMap();
    }

    checkMarkersAndCenterMap = () => {
        if (this.state.markers.length > 0) {
            this.centerMapToMarkers();
        } else {
            setTimeout(this.checkMarkersAndCenterMap, 100);
        }
    };

    centerMapToMarkers = (mapProps, map) => {
        const bounds = new window.google.maps.LatLngBounds();
        if (map) {
            this.setState({
                mapInstance: map
            })
        }

        this.state.markers.forEach((marker) => {
            bounds.extend(new window.google.maps.LatLng(marker.latitude, marker.longitude));
        });

        if (this.state.mapInstance) {
            this.state.mapInstance.fitBounds(bounds);
        }
    };

    render() {

        const columns = [
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '15px', fontWeight: 500 }}>Placa</div>
                },
                dataIndex: 'plate',
                key: 'plate',
                align: 'center',
                width: 80,
                render: (row) => {
                    return (
                        <div style={{ alignContent: 'center', fontSize: '14px' }}>{row}</div>
                    );
                },
                ...this.tableSearch.getColumnSearchProps('plate')
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '15px', fontWeight: 500 }}>Tipo</div>
                },
                dataIndex: 'description',
                key: 'description',
                align: 'center',
                render: (row) => {
                    return row === "lightingtower" ?
                        <Tooltip title={"Torre de Iluminação"}>
                            <img src={blackTowerIllumination}
                                style={{ width: "20px" }} alt='Torre de Iluminação' />
                        </Tooltip>
                        : row === "compressor" ?
                            <Tooltip title={"Compressor"}>
                                <img src={blackCompressor}
                                    style={{ width: "20px" }} alt='Compressor' />
                            </Tooltip>
                            : row === "electricGenerator" ?
                                <Tooltip title={"Gerador Elétrico"}>
                                    <img src={blackElectricGenerator}
                                        style={{ width: "20px" }} alt='Gerador Elétrico' />
                                </Tooltip>
                                :
                                <Tooltip title={"Sem Imagem"}>
                                    <img src={noImage} style={{ width: "20px" }} alt='Sem Imagem' />
                                </Tooltip>

                },
                width: 120,

            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '15px', fontWeight: 500 }}>Última Mensagem</div>
                },
                dataIndex: 'date',
                key: 'date',
                align: 'center',
                render: (row) => {
                    const dateTime = row && Moment(row).format('DD/MM/YYYY HH:mm:ss')
                    return (
                        <div style={{ alignContent: 'center', fontSize: '14px' }}>{dateTime}</div>
                    );
                },
                width: 150,

            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '15px', fontWeight: 500 }}>Ignição</div>
                },
                dataIndex: 'ignition',
                key: 'ignition',
                align: 'center',
                width: 80,
                render: (row) => {
                    return row === "ON" ? <>
                        <img src={ignicao}
                            style={{ width: "20px", filter: "invert(43%) sepia(67%) saturate(415%) hue-rotate(71deg) brightness(93%) contrast(100%)" }} alt='Chave Ligada' />
                    </> : <>
                        <img src={ignicao}
                            style={{ width: "20px", filter: "invert(73%) sepia(14%) saturate(227%) hue-rotate(135deg) brightness(89%) contrast(82%)" }} alt='Chave Desligada' />
                    </>
                },

            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '15px', fontWeight: 500 }}>Horímetro [hh:mm]</div>
                },
                dataIndex: 'horimeter',
                key: 'horimeter',
                align: 'center',
                width: 150,
                render: (text) => {
                    const hours = Math.floor(text / 60).toLocaleString('pt-br');
                    const minutes = Math.floor(text % 60);
                    return <div style={{ fontSize: '14px' }}>{`${hours}:${minutes.toString().padStart(2, '0')}`}</div>
                },

            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '15px', fontWeight: 500 }}>Bateria [V]</div>
                },
                dataIndex: 'mainBattery',
                key: 'mainBattery',
                align: 'center',
                width: 120,
                render: (row) => {
                    return (
                        <div style={{ alignContent: 'center', fontSize: '14px' }}>{row}</div>
                    );
                },

            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '15px', fontWeight: 500 }}>Bloqueio</div> //here
                },
                dataIndex: 'output1',
                key: 'output1',
                align: 'center',
                render: (_, data) => {
                    return data.output1 === "0" ? <>
                        <LockOpenTwoTone style={{ width: '20px', filter: "invert(73%) sepia(14%) saturate(227%) hue-rotate(135deg) brightness(89%) contrast(82%)" }} />
                    </> : data.output1 === "1" ? <>
                        <LockTwoTone style={{ width: '20px', color: '#ff0000' }} />
                    </> : <>
                        <LockTwoTone style={{ width: '20px', color: '#ff0000' }} />
                    </>
                },

                width: 90
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '15px', fontWeight: 500 }}>Endereço</div>
                },
                dataIndex: 'address',
                key: 'address',
                align: 'center',
                width: 500,
                render: (row) => {
                    return (
                        <div style={{ alignContent: 'center', fontSize: '14px' }}>{row}</div>
                    );
                },

            },
        ];


        const paginationConfig = {
            defaultPageSize: this.state.tablePageSize,
            total: this.state.totalRegisters,
            onChange: (page, pageSize) => {
                this.setState({
                    tablePageSize: pageSize,
                    currentPage: page
                });

                this.getData(this.state.plateName, pageSize, page);
            },
        }

        const paginationTable = this.state.totalRegisters === 0 ? false : paginationConfig;
        return (
            <>
                <AppLayout >
                    {this.state.loading && (
                        <Loading />
                    )}

                    <Row style={{ height: '100%' }}>
                        <Col span={24}>
                            <div style={{ width: '100%', height: '50vh' }}>
                                <Map
                                    //ref={(mapInstance) => this.map = mapInstance}
                                    mapId={'map'}
                                    google={this.props.google}
                                    zoom={this.state.zoom}
                                    zoomControl={true}
                                    zoomControlOptions={{
                                        style: window.google.maps.ZoomControlStyle.SMALL,
                                        position: window.google.maps.ControlPosition.RIGHT_BOTTOM
                                    }}
                                    scrollwheel={true}
                                    scaleControl={true}
                                    streetViewControl={true}
                                    streetViewControlOptions={{
                                        position: window.google.maps.ControlPosition.RIGHT_BOTTOM
                                    }}
                                    panControl={true}
                                    mapTypeControl={true}
                                    onReady={this.centerMapToMarkers}
                                >


                                    {this.state.selectedMarker.length <= 0 && this.state.markers.length > 0 && this.state.markers.map((place, i) => {
                                        return <Marker
                                            key={`marker-${i + 1}`}
                                            label={{
                                                className: styles.labelMap,
                                                text: place.plate,
                                                fontFamily: "Arial",
                                                fontSize: "14px",
                                                color: "white",

                                            }}
                                            title={place.plate}
                                            information={place}
                                            position={{ lat: place.latitude, lng: place.longitude }}
                                            onClick={this.onMarkerClick}
                                            icon={{
                                                url: place.description === "lightingtower" ? towerIllumination : place.description === "compressor" ? compressor : electricGenerator,
                                                origin: new window.google.maps.Point(0, 0),
                                                anchor: new window.google.maps.Point(0, 35),
                                                scaledSize: new window.google.maps.Size(35, 35),
                                                labelOrigin: new window.google.maps.Point(20, -15),
                                            }}
                                        />
                                    })}

                                    {this.state.selectedMarker.length > 0 && this.state.markers.length > 0 && this.state.markers.filter(place => place.plate === this.state.selectedMarker[0].plate).map((place, i) => {
                                        return <Marker
                                            key={`marker-${i + 1}`}
                                            label={{
                                                className: styles.labelMap,
                                                text: place.plate,
                                                fontFamily: "Arial",
                                                fontSize: "14px",
                                                color: "white",

                                            }}
                                            title={place.plate}
                                            information={place}
                                            position={{ lat: place.latitude, lng: place.longitude }}
                                            onClick={this.onMarkerClick}
                                            icon={{
                                                url: place.description === "lightingtower" ? towerIllumination : place.description === "compressor" ? compressor : electricGenerator,
                                                origin: new window.google.maps.Point(0, 0),
                                                anchor: new window.google.maps.Point(0, 35),
                                                scaledSize: new window.google.maps.Size(35, 35),
                                                labelOrigin: new window.google.maps.Point(20, -15),
                                            }}
                                        />
                                    })}

                                    <InfoWindow
                                        marker={this.state.activeMarker}
                                        onClose={this.onInfoWindowClose}
                                        visible={this.state.showingInfoWindow}
                                    >
                                        <div>
                                            <h5>Informações Adicionais</h5>
                                            <p><b>Placa: </b>{this.state.selectedPlace.plate}</p>
                                            <p><b>Dispositivo: </b>{this.state.selectedPlace.deviceId}</p>
                                            {/* <p><b>Odômetro: </b>{this.state.selectedPlace.odometer}</p> */}
                                            <p><b>Horímetro: </b>{this.state.selectedPlace.horimeter}</p>
                                            <p><b>Bateria Principal: </b>{this.state.selectedPlace.mainBattery}</p>
                                        </div>
                                    </InfoWindow>
                                </Map>
                            </div>
                        </Col>
                        <Col span={24}>
                            <Card bodyStyle={{ paddingLeft: 5, paddingRight: 5, paddingBottom: 5, paddingTop: 5 }} style={{ height: '100%' }}>
                                {/* <Select
                                    showSearch
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>
                                        optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                                    }
                                    onChange={e => {
                                        this.setState({ plateName: e, currentPage: 1 });

                                        this.delayOnChangeSearch(e, 1);
                                    }}
                                    placeholder="Pesquisar por placa"
                                    options={this.state.plates ? this.state.plates : null}
                                    size='small'
                                    style={{ marginBottom: '5px', width: '30%', height: '100%' }}
                                /> */}
                                <Table
                                    pagination={paginationTable}
                                    size='small'
                                    scroll={{ x: "max-content" }}
                                    style={{ width: '100%', height: '100%' }}
                                    columns={columns}
                                    dataSource={this.state.markers}
                                    loading={this.state.showLoading}
                                    rowClassName={(record, index) => index % 2 === 0 ? 'row-dark ' : 'row-light'}
                                    onRow={(record) => {
                                        return {
                                            onClick: () => {
                                                this.handleRowClicked(record)
                                            }
                                        };
                                    }}
                                />
                            </Card>
                        </Col>
                    </Row>
                </AppLayout>
            </>
        );
    }
}

export default GoogleApiWrapper({
    apiKey: process.env.REACT_APP_API_KY_GOOGLE_MAPS,
    LoadingContainer: () => <Loading />
})(ArlugHome);